import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=23966a89&scoped=true&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"
import style0 from "./Layout.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Layout.vue?vue&type=style&index=1&id=23966a89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23966a89",
  null
  
)

export default component.exports